<template>
    <div>
        <div v-if="userData" class="content">

            <b-alert
                v-model="showChangesAlert"
                class="position-fixed fixed-bottom m-0 rounded-0"
                style="z-index: 2000; box-shadow: 0px 6px 6px 4px #999"
                variant="white"
                >
                <b-row align-v="center" align-h="center" class="">
                    <b-col cols="9">
                        <strong>Heads up!</strong> You've changed permissions in this user's {{expandedRole}} role
                    </b-col>
                    <b-col cols="3">
                        <base-button type="neutral" @click="discardPermissionsChanges">
                            Discard
                        </base-button>
                        <base-button type="success" @click="showConfirmPermissionsChanges">
                            Save changes
                        </base-button>
                    </b-col>
                </b-row>

            </b-alert>

            <b-container fluid class="mt-4">

                <stats-card title="User details" type="default" :sub-title="userData.name" icon="fas fa-user">

                    <template slot="actions">
                        <a class="dropdown-item" href="javascript:void(0)" @click="toggleUserActiveStatus">{{`${userData.status == 'active' ? 'Disable' : 'Activate'}`}}  user</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="toggleShowPassword">Change password</a>
                    </template>

                    <template slot="append">

                        <base-alert type="warning" v-if="userData.status =='pending'">
                            This user is currently <strong>inactive</strong>
                        </base-alert>

                        <base-alert type="danger" v-if="userData.status =='deleted'">
                            This user is currently <strong>disabled</strong>
                        </base-alert>
                        <b-card no-bod class="tab-wrapper">
                            <b-card-header header-tag="nav">
                                <b-nav card-header tabs>
                                    <b-nav-item @click="setActiveTab(1)" :active="activeTab == 1">Details</b-nav-item>
                                    <b-nav-item @click="setActiveTab(0)" :active="activeTab == 0"><i class="fas fa-shield-alt"></i> Permissions</b-nav-item>
                                    <b-nav-item @click="setActiveTab(2)" :active="activeTab == 2"><i class="fas fa-mobile-alt"></i> Push Notifications</b-nav-item>
                                    <b-nav-item @click="setActiveTab(3)" :active="activeTab == 3"><i class="fas fa-clipboard-list"></i> Reports</b-nav-item>
                                </b-nav>
                            </b-card-header>

                            <div class="tab-container" v-if="activeTab == 3">
                                <entity-picker v-if="userReports.length > 0"
                                    :canEdit="true"
                                    :canSelect="false"
                                    placeHolder="Start typing something..."
                                    apiEndpoint="getReports"
                                    :selected="userReports"
                                    editPath="/reports/"
                                    :tableColumns= userReportTableColumns
                                    rootProp="reports"
                                    :tableOptions="userReportTableOptions"
                                >
                                </entity-picker>
                                <base-alert v-else type="info" >
                                    <strong>No reports found</strong> Head to the Reports section to add this user to existing reports
                                </base-alert>
                            </div>

                            <div class="tab-container" v-if="activeTab == 1">
                                <base-input label="Full name:" v-model="newUserData.name"></base-input>
                                <base-input label="Email address:" v-model="newUserData.email"></base-input>
                                <base-input label="Phone number:" v-model="newUserData.phone"></base-input>

                                <form-address @onSetAddress="setUserAddress" :address="newUserData.address"></form-address>

                                <div class="" align="right">
                                    <base-button type="primary" @click="updateUser">
                                        Update details
                                    </base-button>
                                </div>
                            </div>

                            <div class="tab-container" v-if="activeTab == 0">

                                <base-alert type="info" v-if="userPermissions.length == 0">
                                    <strong>No permissions found</strong> This user has no permissions set yet. Go ahead and create one!
                                </base-alert>

                                <base-alert type="warning" :action="{label: 'How permissions work',callback:toggleShowPermissionsHelp}">
                                    <strong>Not sure watcha doing?</strong> Read this first
                                </base-alert>

                                <div :key="permission.role" v-for="permission in userPermissions">

                                    <card :class="`no-border-card ${expandedRole != null && expandedRole != permission.role ? 'disabled' : ''}`" body-classes="" footer-classes="">

                                        <b-row align-v="center" align-h="between" class="pl-3">
                                          <b-col cols="9">
                                            <h3>
                                              {{permission.role}}
                                              <template v-if="permission.role !== 'CORE'">
                                                <br><small class="text-muted">{{permission.organisations.length}} org(s) | {{permission.farms.length}} farm(s) | {{permission.orchards.length}} orchard(s)</small>
                                              </template>
                                            </h3>
                                          </b-col>
                                          <b-col cols="3" align="right" v-if="(expandedRole == null || expandedRole == permission.role)">
                                            <base-button v-if="expandedRole != permission.role" @click="onViewEditPermissions(permission.role)" type="dark">
                                              <i class="fas fa fa-pencil"></i>
                                            </base-button>
                                            <base-button v-if="expandedRole == permission.role && !arePermissionsDirty()" @click="discardPermissionsChanges" type="dark">
                                              <i class="fas fa fa-caret-up"></i>
                                            </base-button>
                                            <base-button type="danger" @click="showConfirmDelete = true" v-if="expandedRole == permission.role && !arePermissionsDirty()">
                                              <i class="fas fa fa-times"></i>
                                            </base-button>
                                          </b-col>
                                        </b-row>

                                        <div v-if="permission.role !== 'CORE'">
                                          <div class="mt-4">
                                            <ul class="nav nav-pills" v-if="expandedRole == permission.role">
                                                <li class="nav-item">
                                                    <a :class="activeSubTab == 1 ? 'nav-link active' : 'nav-link'" @click="activeSubTab = 1" href="javascript:void(0)">Permissions</a>
                                                </li>
                                                <li class="nav-item">
                                                    <a :class="activeSubTab == 2 ? 'nav-link active' : 'nav-link'" @click="activateOrgPermission(2,permission.organisations)" href="javascript:void(0)">
                                                        Org(s)
                                                        <span :class="`ml-1 badge badge-${activeSubTab == 2 ? 'white' : 'dark'}`">
                                                            <strong :class="`text-${activeSubTab == 2 ? 'dark' : 'white'}`">
                                                                {{permission.organisations.length}}
                                                            </strong>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a :class="activeSubTab == 3 ? 'nav-link active' : 'nav-link'" @click="activateGroupPermission(3, permission.farms)" href="javascript:void(0)">
                                                        Farm(s)
                                                        <span :class="`ml-1 badge badge-${activeSubTab == 2 ? 'white' : 'dark'}`">
                                                            <strong :class="`text-${activeSubTab == 2 ? 'dark' : 'white'}`">
                                                                {{permission.farms.length}}
                                                            </strong>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a :class="activeSubTab == 4 ? 'nav-link active' : 'nav-link'" @click="activateGroupPermission(4, permission.orchards)" href="javascript:void(0)">
                                                        Orchard(s)
                                                        <span :class="`ml-1 badge badge-${activeSubTab == 2 ? 'white' : 'dark'}`">
                                                            <strong :class="`text-${activeSubTab == 2 ? 'dark' : 'white'}`">
                                                                {{permission.orchards.length}}
                                                            </strong>
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>

                                        <!-- ORGS LIST -->
                                        <div v-if="activeSubTab == 2 && expandedRole == permission.role" class="mt-5">
                                            <entity-picker
                                                :key="`orgPicker${permission.role}`"
                                                @onSelect="handleOrgUpdate"
                                                placeHolder="Search for orgs to add"
                                                apiEndpoint="getOrgs"
                                                rootProp="organisations"
                                                :multiple="true"
                                                :selected="permissionOrgs"
                                                :canBeEmpty="true"
                                            >
                                            </entity-picker>
                                        </div>

                                        <!-- FARMS LIST -->
                                        <div v-if="activeSubTab == 3 && expandedRole == permission.role" class="mt-5">
                                            <entity-picker
                                                :key="`farmPicker${permission.role}`"
                                                @onSelect="handleFarmUpdate"
                                                placeHolder="Search for farms to add"
                                                apiEndpoint="getFarms"
                                                rootProp="farms"
                                                :multiple="true"
                                                :selected="permissionFarms"
                                                :canBeEmpty="true"
                                            >
                                            </entity-picker>
                                        </div>

                                        <!-- ORCHARDS LIST -->
                                        <div v-if="activeSubTab == 4 && expandedRole == permission.role" class="mt-5">
                                            <entity-picker
                                                :key="`groupPicker${permission.role}`"
                                                @onSelect="handleGroupUpdate"
                                                placeHolder="Search for orchards to add"
                                                apiEndpoint="getGroups"
                                                :multiple="true"
                                                rootProp="orchards"
                                                :selected="permissionGroups"
                                                :canBeEmpty="true"
                                            >
                                            </entity-picker>
                                        </div>

                                        <div v-if="activeSubTab == 1 &&  expandedRole == permission.role && availablePermissions && canViewPermissions()">

                                            <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap pl-0 pt-5">
                                                <div>
                                                    <base-input v-on:input="filterPermissions" v-model="permissionsFilter"  placeholder="Filter permissions"> </base-input>
                                                </div>
                                            </b-col>

                                            <el-table
                                                class="table-responsive table-flush"
                                                header-row-class-name="thead-light"
                                                row-key="id"
                                                :data="filteredPermissions"
                                                >
                                                <el-table-column label="Permission" min-width="220px" prop="description" sortable>
                                                    <template v-slot="{ row }">
                                                        <b>{{ row.description }}</b>
                                                    </template>
                                                </el-table-column>

                                                <el-table-column label="System name" prop="permission" sortable>
                                                    <template v-slot="{ row }">
                                                        <pre>{{ row.permission }}</pre>
                                                    </template>
                                                </el-table-column>

                                                <el-table-column min-width="120px" label="" prop="active" sortable align="center">
                                                    <template v-slot="{ row }">
                                                        <div class="d-flex justify-content-center">
                                                            <base-switch v-on:input="onPermissionToggle(row.name)" v-model="permissionsMatrix[expandedRole][row.permission]"></base-switch>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                            </el-table>

                                        </div>
                                      </div>
                                      <div v-if="permission.role === 'CORE' && expandedRole === permission.role">
                                        <span>This permission determines whether or not the user can access the Control Panel.</span>
                                      </div>
                                    </card>
                                </div>

                                <b-row align-v="center" align-h="between" class="" v-if="expandedRole == null">
                                    <b-col cols="12" align="right">
                                        <base-button type="success" @click="addRolePermission">
                                            <i class="fas fa fa-plus"></i> Assign Role / Permissions set
                                        </base-button>
                                    </b-col>
                                </b-row>

                            </div>

                            <div class="tab-container" v-if="activeTab == 2">

                                <ul v-if="userData.settings.push.hasEndpoints">
                                    <li v-for="endpoint in userData.settings.push.endpoints" :key="endpoint.token">
                                        {{endpoint.provider}} device:
                                        <span :class="`ml-1 badge badge-${endpoint.enabled == true ? 'success' : 'danger'}`">
                                            <strong class="text-white">
                                                {{endpoint.enabled ? 'ON' : 'OFF'}}
                                            </strong>
                                        </span>
                                        <!-- {{endpoint.token}} -->
                                    </li>
                                </ul>

                                <base-alert v-else type="info">
                                    This user's Push Notifications are not enabled on any device.
                                </base-alert>

                            </div>
                        </b-card>
                    </template>
                </stats-card>
            </b-container>
        </div>

        <!-- MODALS -->
        <modal :show.sync="showPermissionsHelp">
            <h6 slot="header" class="modal-title">About Permissions</h6>
            <p>Permissions are distributed to a user according to a trickle-down "pyramid" logic. This simply means that the entities a user can have access to obey the following hierarchy (from top to bottom):</p>
            <ul>
                <li>Organisation</li>
                <li>Farm</li>
                <li>Orchard</li>
            </ul>
            <p>Granting a user access to an Organisation will therefore also grant them access to all farms &amp; orchards belonging to that org, with no possibility of cherry-picking children entities from their parent.</p>
            <p>You therefore need to think about what access level this particular user needs. If it's just one orchard, then grant access to that unique orchard and leave the farm / org section empty. If this user should have access to let's say the 50 orchards belonging to a farm, grant access to that farm only and its children orchards will be automatically added.</p>
            <p>The same logic goes when removing a user access to entities.</p>
            <p>As a rule of thumb and unless you're willing to mass-assign numerous farms / orchards to a user, always work your way up from the smallest entity available, which is Orchard.</p>
            <p>Please note that any sub-entity added to a parent entity will also be added to a user's permissions if they already have access to that parent entity.</p>
            <base-alert>A user will always be automatically logged out each time their permissions are updated.</base-alert>

            <template slot="footer">
                <base-button type="primary" @click="showPermissionsHelp = false">Got it</base-button>
            </template>
        </modal>

        <modal :show.sync="showChangePassword">
            <h6 slot="header" class="modal-title">Change password</h6>

            <base-alert>
                User will be automatically logged out.
            </base-alert>

            <base-input label="New password" v-model="newPassword" placeholder=""></base-input>

            <template slot="footer">
                <base-button type="blank" @click="showChangePassword = false">Cancel</base-button>
                <base-button :disabled="newPassword == '' || newPassword.length < 6" type="primary" @click="changePassword">Update password</base-button>
            </template>
        </modal>

        <modal :show.sync="showCognitoResetPassword">
            <h6 slot="header" class="modal-title">Reset user's password</h6>
            <base-alert v-if="resetRequired">
                Account password has already been reset. A code will be sent to the user the next time they log in.
            </base-alert>
            <base-alert v-else>
                User will be prompted to reset their password next time they log in.
            </base-alert>

            <template slot="footer">
                <base-button type="blank" @click="showCognitoResetPassword = false" v-if="!resetRequired">Cancel</base-button>
                <base-button type="primary" @click="resetCognitoPassword" v-if="!resetRequired">Reset password</base-button>
            </template>
        </modal>

        <modal :show.sync="showToggleUserActiveStatus">
            <h6 slot="header" class="modal-title">Toggle user active status</h6>

            <base-alert>
                <div v-if="!userInCognito">User will be logged out if you're deactivating them.</div>
                <div v-if="userInCognito">User won't be able to log in again if you're deactivating them.</div>
            </base-alert>

            <template slot="footer">
                <base-button type="blank" @click="showToggleUserActiveStatus = false">Cancel</base-button>
                <base-button type="primary" @click="handleUserActiveStatusUpdate">Update active status</base-button>
            </template>
        </modal>

        <modal :show.sync="showAddRole">
            <h6 slot="header" class="modal-title">Add new role / permissions set</h6>

            <base-alert>
                Select from existing roles or <a href="/#/access/roles/create">create a new one</a>:
            </base-alert>

            <b-form-select v-on:change="displayRolePermissions" v-if="addRoleOptions.length > 0" v-model="newPermission.role" :options="addRoleOptions"></b-form-select>

            <b-card no-bod class="tab-wrapper" v-if="newPermission.role != null && !newPermission.role.startsWith('CORE')">
                <b-card-header header-tag="nav">
                    <b-nav card-header tabs>
                        <b-nav-item @click="setActiveCreateTab(1)"  :active="activeCreateTab == 1">Orchards</b-nav-item>
                        <b-nav-item @click="setActiveCreateTab(2)" :active="activeCreateTab == 2">Farms</b-nav-item>
                        <b-nav-item @click="setActiveCreateTab(3)" :active="activeCreateTab == 3">Orgs</b-nav-item>
                        <b-nav-item @click="setActiveCreateTab(4)" :active="activeCreateTab == 4">Permissions</b-nav-item>
                    </b-nav>
                </b-card-header>

                <div class="tab-container" v-if="activeCreateTab == 1">

                    <entity-picker
                        :key="`newRoleOrchardPicker`"
                        @onSelect="handleNewRoleOrchard"
                        :selected="newPermissionOrchards"
                        placeHolder="Search for orchards to add"
                        apiEndpoint="getGroups"
                        rootProp="orchards"
                        :multiple="true"
                        :canBeEmpty="true"
                    >
                    </entity-picker>

                </div>

                <div class="tab-container" v-if="activeCreateTab == 2">

                    <entity-picker
                        :key="`newRoleFarmPicker`"
                        @onSelect="handleNewRoleFarm"
                        :selected="newPermissionFarms"
                        placeHolder="Search for farms to add"
                        apiEndpoint="getFarms"
                        rootProp="farms"
                        :multiple="true"
                        :canBeEmpty="true"
                    >
                    </entity-picker>

                </div>

                <div class="tab-container" v-if="activeCreateTab == 3">

                    <base-alert type="warning">You're setting permissions for a <strong>whole organisation</strong></base-alert>

                    <entity-picker
                        :key="`newRoleOrgPicker`"
                        @onSelect="handleNewRoleOrg"
                        :selected="newPermissionOrgs"
                        placeHolder="Search for orgs to add"
                        apiEndpoint="getOrgs"
                        rootProp="organisations"
                        :multiple="true"
                        :canBeEmpty="true"
                    >
                    </entity-picker>
                </div>

                <div class="tab-container" v-if="activeCreateTab == 4">
                    <el-table
                    class="table-responsive table-flush"
                    header-row-class-name="thead-light"
                    row-key="id"
                    :data="filteredPermissions"
                    >
                    <el-table-column label="Permission" min-width="220px" prop="description" sortable>
                        <template v-slot="{ row }">
                            <b>{{ row.description }}</b>
                        </template>
                    </el-table-column>

                    <!-- <el-table-column label="System name" prop="permission" sortable>
                        <template v-slot="{ row }">
                            <pre>{{ row.permission }}</pre>
                        </template>
                    </el-table-column> -->

                    <el-table-column min-width="120px" label="" prop="active" sortable align="center">
                        <template v-slot="{ row }">
                            <div class="d-flex justify-content-center">
                                {{rolePermissionsDisplay[newPermission.role][row.permission]}}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                </div>
            </b-card>


            <template slot="footer">
                <base-button type="blank" @click="showAddRole = false">Cancel</base-button>
                <base-button :disabled="isAddRoleDisabled" type="success" @click="assignRoleToUser">Assign role</base-button>
            </template>
        </modal>

        <modal :show.sync="showConfirmOrgRemoval">
            <h6 slot="header" class="modal-title">Confirm removal?</h6>

            <base-alert type="danger">
                Removing this Org will also remove all associated orchards form this user's permissions.
            </base-alert>

            <template slot="footer">
                <base-button type="blank" @click="showConfirmOrgRemoval = false">Cancel</base-button>
                <base-button type="danger">Rock n roll</base-button>
            </template>
        </modal>

        <modal :show.sync="showConfirmChanges">
            <h6 slot="header" class="modal-title">Confirm changes?</h6>

            <base-alert>
                A new custom role will be created and assigned to this user. Please enter a role name / description.
            </base-alert>

            <base-input label="Name" v-model="newRole.name" placeholder=""></base-input>
            <base-input label="Description" v-model="newRole.description" placeholder=""></base-input>

            <template slot="footer">
                <base-button type="blank" @click="showConfirmChanges = false">Cancel</base-button>
                <base-button type="success" @click="savePermissionChanges">Create custom role</base-button>
            </template>
        </modal>

        <modal :show.sync="showConfirmDelete">
            <h6 slot="header" class="modal-title">Confirm removal?</h6>

            <p v-if="expandedRole === 'CORE'">
              You are about to remove the Control Panel permission from a user. They will no longer be able to access the Control Panel.
            </p>
            <p v-else>
              You are about to remove an ENTIRE role &amp; set of permissions from a user. They will be automatically logged out of all RapidAIM services.
            </p>

            <template slot="footer">
                <base-button type="blank" @click="showConfirmDelete = false">Cancel</base-button>
                <base-button type="danger" @click="removeRole">Remove</base-button>
            </template>
        </modal>
        <!-- END MODALS -->
    </div>
</template>

<script>

import api from '@/api';

import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn, Tooltip } from 'element-ui';
import { UserModel } from '@/models/user/user';
import { RoleModel } from '@/models/access/role';
import { UserPermission } from '@/models/user/permission';
import BaseAlert from '../components/BaseAlert.vue';
import { tableColumns as userReportTableColumns, tableOptions as userReportTableOptions } from '@/config/ReportTable';
import { StringHelper } from '../helpers/StringHelper';

export default {
  components: {
    [BaseAlert.name]: BaseAlert,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
        userReports: [],
        userInCognito: false,
        showChangePassword: false,
        showCognitoResetPassword: false,
        resetRequired: false,
        newPassword: '',
        userData: null,
        newUserData: null,
        newRole: new RoleModel(),
        newPermission: new UserPermission(),
        availablePermissions: null,
        availableRoles: null,
        filteredPermissions: null,
        expandedRole: null,
        permissionsMatrix: {},
        rolePermissionsDisplay:{},
        permissionsFilter: '',
        showChangesAlert: false,
        showConfirmChanges: false,
        showPermissionsHelp: false,
        showConfirmOrgRemoval: false,
        showConfirmDelete: false,
        showAddOrchardToRole: false,
        showToggleUserActiveStatus: false,
        hasNoPermissions: false,
        showAddRole: false,
        // addRoleSelected: null,
        addRoleOptions: [],
        activeTab: 1,
        activeSubTab: 1,
        activeCreateTab: 1,
        permissionGroups: [],
        permissionOrgs: [],
        permissionFarms: [],
        userPermissions: [],
        originalPermissionGroups: [],
        originalPermissionOrgs: [],
        originalPermissionFarms: [],
        newPermissionOrchards: [],
        newPermissionFarms: [],
        newPermissionOrgs: [],
        userReportTableColumns: userReportTableColumns,
        userReportTableOptions: userReportTableOptions,
    };
  },
  computed: {
    isAddRoleDisabled() {
      let isDisabled = false;
      if (!this.newPermission.role || !this.newPermission.role.startsWith('CORE')) {
        isDisabled = this.newPermissionOrgs.length === 0 &&
                    this.newPermissionOrchards.length === 0 &&
                    this.newPermissionFarms.length === 0;
        }
      return isDisabled;
    }
  },
  created: function() {
    this.fetchUser()
  },
  methods: {
    changePassword: async function() {
      this.showChangePassword = false
      this.$emit('loading', true);
      let updatePayload = {
          password: {
              new: this.newPassword,
              confirm: this.newPassword
          }
      }
      const results = await api.updateUser(this.userData.id,updatePayload)
      this.$emit('onApiResult', "New password has been set");
      this.logUserOut()
    },
    async toggleShowPassword() {
      const handleError = (error) => {
        if (error === 'User does not exist.') {
          this.showChangePassword = true;
        }
        else (console.error(error));
      }
      const res = await api.cognitoGetUser(this.userData.id, handleError);
      if (res) {
        this.showCognitoResetPassword = true;

        if (res.UserStatus === "RESET_REQUIRED") {
          this.resetRequired = true;
        }
      }
    },
    async resetCognitoPassword() {
      this.$emit('loading', true);

      const res = await api.cognitoResetUserPassword(this.userData.id, {email: this.userData.email});

      this.showCognitoResetPassword = false;
      this.$emit('loading', false);

      if (res) {
        this.$emit('onApiResult', "User's password has been reset");
      }
    },
    toggleShowPermissionsHelp() {
        this.showPermissionsHelp = true
    },
    handleNewRoleFarm(farms) {
        this.newPermissionFarms = farms
    },
    handleNewRoleOrchard(orchards) {
        this.newPermissionOrchards = orchards
    },
    handleNewRoleOrg(orgs) {
        this.newPermissionOrgs = orgs
    },
    logUserOut: async function() {
        this.showLogUserOut = false
        this.$emit('loading', true);
        await api.logoutUsers([this.userData.id])
        this.$emit('loading', false);
        this.$emit('onApiResult', "User is now logged out");
    },
    setActiveTab: async function(tab) {
        if(tab == 0) {
            if(this.userPermissions.length == 0) {
                this.$emit('loading', true);
                let upResponse = await api.getUserPermissions(this.$route.params.id)
                this.$emit('loading', false);
                this.userPermissions = upResponse.permissions
                if(this.userPermissions.length == 0) {
                    this.expandedRole = null
                }
            }
        }
        if(tab == 1) {
            this.discardPermissionsChanges()
        }
        if(tab == 3) {
            if(this.userReports.length == 0) {
                this.fetchUserReports()
            }
        }
        this.activeTab = tab
    },
    fetchUserReports: async function() {
        this.$emit('loading', true);
        const results = await api.getUserReports(this.$route.params.id)
        this.$emit('loading', false);
        this.userReports = results;
    },
    setUserAddress(address) {
        this.newUserData.address.populate(address)
    },
    fetchUser: async function() {
        this.$emit('loading', true);
        const results = await api.getUser(this.getUserId())
        this.$emit('loading', false);
        this.userData = new UserModel(results);
        this.newUserData = new UserModel(results);
        if(this.userPermissions.length == 0) {
            this.hasNoPermissions = true;
        }
    },
    toggleUserActiveStatus: async function() {
        const handleError = (error) => {
          if (error === 'User does not exist.') {
            this.showToggleUserActiveStatus = true;
          }
            else (console.error(error));
        }
        const res = await api.cognitoGetUser(this.userData.id, handleError);

        if (res) {
          this.showToggleUserActiveStatus = true;
          this.userInCognito = true;
        }
    },
    handleUserActiveStatusUpdate: async function () {
      this.newUserData.status = this.userData.status == 'active' ? 'deleted' : 'active'

      let res;
      if (this.userInCognito) {
        if (this.userData.status === 'active') {
          res = await api.cognitoDisableUser(this.userData.id, {email: this.userData.email})
        }
        else {
          res = await api.cognitoEnableUser(this.userData.id, {email: this.userData.email})
        }
      }

      if (this.userInCognito && res || !this.userInCognito) {
        await this.updateUser();
      }

      this.showToggleUserActiveStatus = false;
    },
    assignRoleToUser: async function() {
        this.showAddRole = false
        this.$emit('loading', true);
        this.newPermission.orchards = this.newPermissionOrchards
        this.newPermission.farms = this.newPermissionFarms
        this.newPermission.organisations = this.newPermissionOrgs
        const p = await api.addRoleToUser(this.userData.id,this.newPermission.export())
        this.$emit('onApiResult', `Role added to user`);
        this.logUserOut()
        this.userPermissions = []
        this.newPermission = new UserPermission()
        this.setActiveTab(0)
    },
    handleGroupUpdate: async function(groups) {
        let groupIds = groups.map((g) => g.id)
        let originalGroupIds = this.originalPermissionGroups.map((g) => g.id)
        let removedGroups = originalGroupIds.filter((g) => !groupIds.includes(g))
        let addedGroups = groupIds.filter((g) => !originalGroupIds.includes(g))
        if(removedGroups.length > 0 || addedGroups.length > 0) {
            if(removedGroups.length > 0) {
                this.$emit('loading', true);
                await api.removeRoleFromUser(this.userData.id,{
                    role: this.expandedRole,
                    orchards: removedGroups
                })
                this.$emit('onApiResult', `${removedGroups.length} orchard(s) removed from user`);
                this.$emit('loading', false);
            }
            if(addedGroups.length > 0) {
                this.$emit('loading', true);
                await api.addRoleToUser(this.userData.id,{
                    role: this.expandedRole,
                    orchards: addedGroups
                })
                this.$emit('onApiResult', `${addedGroups.length} orchard(s) added to user`);
                this.$emit('loading', false);
            }
            this.userPermissions = []
            this.logUserOut()
            await this.setActiveTab(0)
            await this.getCurrentEntities(this.expandedRole)
        }
    },
    handleFarmUpdate: async function(farms) {
        let farmIds = farms.map((g) => g.id)
        let originalFarmIds = this.originalPermissionFarms.map((g) => g.id)
        let removedFarms = originalFarmIds.filter((g) => !farmIds.includes(g))
        let addedFarms = farmIds.filter((g) => !originalFarmIds.includes(g))
        if(removedFarms.length > 0 || addedFarms.length > 0) {
            if(removedFarms.length > 0) {
                this.$emit('loading', true);
                await api.removeRoleFromUser(this.userData.id,{
                    role: this.expandedRole,
                    farms: removedFarms
                })
                this.$emit('onApiResult', `${removedFarms.length} farm(s) removed from user`);
                this.$emit('loading', false);
            }
            if(addedFarms.length > 0) {
                this.$emit('loading', true);
                await api.addRoleToUser(this.userData.id,{
                    role: this.expandedRole,
                    farms: addedFarms
                })
                this.$emit('onApiResult', `${addedFarms.length} farm(s) added to user`);
                this.$emit('loading', false);
            }
            this.userPermissions = []
            this.logUserOut()
            await this.setActiveTab(0)
            await this.getCurrentEntities(this.expandedRole)
        }
    },
    handleOrgUpdate: async function(orgs) {
        let orgIds = orgs.map((g) => g.id)
        let originalOrgIds = this.originalPermissionOrgs.map((g) => g.id)
        let removedOrgs = originalOrgIds.filter((g) => !orgIds.includes(g))
        let addedOrgs = orgIds.filter((g) => !originalOrgIds.includes(g))
        if(removedOrgs.length > 0 || addedOrgs.length > 0) {
            if(removedOrgs.length > 0) {
                this.$emit('loading', true);
                await api.removeRoleFromUser(this.userData.id,{
                    role: this.expandedRole,
                    organisations: removedOrgs
                })
                this.$emit('onApiResult', `${removedOrgs.length} org(s) removed from user`);
                this.$emit('loading', false);
            }
            if(addedOrgs.length > 0) {
                this.$emit('loading', true);
                await api.addRoleToUser(this.userData.id,{
                    role: this.expandedRole,
                    organisations: addedOrgs
                })
                this.$emit('onApiResult', `${addedOrgs.length} org(s) added to user`);
                this.$emit('loading', false);
            }
            this.userPermissions = []
            this.logUserOut()
            await this.setActiveTab(0)
            await this.getCurrentEntities(this.expandedRole)
        }
    },
    setActiveCreateTab(tab) {
        this.activeCreateTab = tab
    },
    activateGroupPermission: async function(tabId, groups) {
        this.activeSubTab = tabId
    },
    activateFarmPermission: async function(tabId, farms) {
        this.activeSubTab = tabId
    },
    activateOrgPermission: async function(tabId, orgs) {
        this.activeSubTab = tabId
    },
    addRolePermission: async function() {
        await this.fetchAvailablePermissions();
        this.showAddRole = true
    },
    updateUser: async function() {
        this.$emit('loading', true);
        let updatePayload = {
            ... this.newUserData.toMetaUpdateJson(this.userData),
            ... this.newUserData.toDetailsUpdateJson(this.userData),
            address: this.newUserData.address
        }
        updatePayload = StringHelper.trimObjectStrings(updatePayload);
        const results = await api.updateUser(this.userData.id,updatePayload)
        this.$emit('onApiResult', "User has been updated successfully");
        this.fetchUser()
    },
    arePermissionsDirty: function() {
        for (var prop in this.permissionsMatrix[this.expandedRole]) {
            let isPermissionGranted = this.permissionsMatrix[this.expandedRole][prop];
            let hasPermissionAlready = this.userPermissions.filter((p) => p.role == this.expandedRole)[0].allows.includes(prop)
            if(
                (isPermissionGranted && !hasPermissionAlready)
                ||
                (!isPermissionGranted && hasPermissionAlready)
            )
                {
                    return true
                }
        }
        return false;
    },
    savePermissionChanges: async function() {
        this.showConfirmChanges = false
        this.newRole.allows = []
        for(let x in this.permissionsMatrix[this.expandedRole]) {
            if(this.permissionsMatrix[this.expandedRole][x]) {
                this.newRole.allows.push(x)
            }
        }
        this.$emit('loading', true);
        let createRole = await api.createRole(this.newRole.exportToCreate())
        this.$emit('loading', false);
    },
    discardPermissionsChanges: function() {
        this.showChangesAlert = false;
        this.permissionsMatrix = {};
        this.expandedRole = null;
        this.permissionsFilter = '';
        this.filterPermissions('');
    },
    showConfirmPermissionsChanges: function() {
        this.showConfirmChanges = true;
    },
    filterPermissions: function(label) {
        let allPermissions = this.availablePermissions;
        if(label.length > 2) {
            this.filteredPermissions = allPermissions.filter((p) => p.description.toLowerCase().indexOf(label.toLowerCase()) != -1 || p.permission.indexOf(label.toLowerCase()) != -1);
        }
        else {
            this.filteredPermissions = allPermissions;
        }
    },
    onPermissionToggle: function(name) {
        this.showChangesAlert = this.arePermissionsDirty();
    },
    hasPermission: function(name, permissionsSet) {
        return permissionsSet.allows.filter((a) => a == name).length > 0;
    },
    getUserId: function() {
        return this.$route.params.id;
    },
    getAvailablePermissions: async function() {
        this.$emit('loading', true);
        const results = await api.getRoles()
        const dis = this;
        this.addRoleOptions = results.roles.map(function(r) {
            return {
                value: r.name,
                text: `${r.name} - ${r.description}`,
                disabled: dis.hasUserRole(r.name)
            }
        })
        this.addRoleOptions.unshift({
            value: null,
            text: "Select..."
        })

        this.availableRoles = results.roles;

        const p = await api.getPermissions()
        this.$emit('loading', false);
        this.availablePermissions = p.permissions;
        this.filteredPermissions = p.permissions;
    },
    hasUserRole: function(role) {
        return this.userPermissions.filter((p) => p.role == role).length > 0;
    },
    removeRole: async function() {
        this.showConfirmDelete = false
        let roleToDelete = this.userPermissions.filter((p) => p.role == this.expandedRole)[0]
        this.$emit('loading', true);
        const p = await api.removeRoleFromUser(this.userData.id,roleToDelete)
        this.$emit('onApiResult', "Role removed from user");
        this.logUserOut()
        this.expandedRole = null
        this.userPermissions = []
        this.setActiveTab(0)
    },
    fetchAvailablePermissions: async function() {
        if(!this.availablePermissions) {
            await this.getAvailablePermissions();
        }
    },
    getCurrentEntities: async function(role) {
        let currentRole = this.userPermissions.filter((p) => p.role == role)[0]
        if (!currentRole || (currentRole.farms.length === 0 && currentRole.orchards.length === 0 && currentRole.organisations.length === 0) ) return

        let entities = await api.getEntitiesNames(currentRole)
        this.permissionGroups = entities.orchards || []
        this.permissionOrgs = entities.organisations || []
        this.permissionFarms = entities.farms || []

        // dirty hack to not reference stuff but works..
        this.originalPermissionGroups = entities.orchards ? JSON.parse(JSON.stringify(entities.orchards)) : []
        this.originalPermissionOrgs = entities.organisations ? JSON.parse(JSON.stringify(entities.organisations)) : []
        this.originalPermissionFarms = entities.farms ? JSON.parse(JSON.stringify(entities.farms)) : []
    },
    onViewEditPermissions: async function(role) {
      if (role !== 'CORE') {
        await this.fetchAvailablePermissions()
        await this.getCurrentEntities(role)

        this.permissionsMatrix[role] = {};
        for(let p in this.availablePermissions) {
            this.permissionsMatrix[role][this.availablePermissions[p].permission] = this.hasPermission(this.availablePermissions[p].permission,this.userPermissions.filter((p) => p.role == role)[0]);
        }
      }
      this.expandedRole = role;
    },
    displayRolePermissions: function(value) {
        this.rolePermissionsDisplay = {}
        this.newPermission.role = value
        this.rolePermissionsDisplay[this.newPermission.role] = {};
        for(let p in this.availablePermissions) {
            this.rolePermissionsDisplay[this.newPermission.role][this.availablePermissions[p].permission] = this.hasPermission(this.availablePermissions[p].permission, this.availableRoles.filter((r) => r.name == this.newPermission.role)[0]);
        }
    },
    canViewPermissions: function() {
        return this.permissionsMatrix[this.expandedRole] != undefined;
    }
  }
};
</script>
